import { combineReducers } from 'redux'
import auth from './auth'
import base from './base'
import creditNote from './creditNote'
import dataPolis from "./dataPolis"
import debitNote from './debitNote'
import theme from './theme/themeSlice'
import newBusiness from "./newBusiness"
import claim from "./claim"

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        creditNote,
        debitNote,
        dataPolis,
        newBusiness,
        claim,
        ...asyncReducers,
    })

    if (action.type === 'RESET_APP') {
        return combinedReducer(undefined, { type: undefined });
    }

    return combinedReducer(state, action)
}

export default rootReducer
